import { ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { PostProcessingTab } from '~/state/atoms/toolsAtoms';
import { POST_PROCESSING_TABS } from './postProcessing/postProcessingTabs';

// ── Picking an operation before the panel opens ──────────────────────
//
// The toolbar button expands into this, so an operation is chosen before
// any panel opens.
//
// The panel keeps its tab strip. Both routes offer the same operations in
// the same order from the same source (postProcessingTabs.ts), so this is
// a second way in rather than a second vocabulary — pick from here to
// arrive on an operation, switch with the tabs once you are there.

export interface PostProcessingMenuProps {
    anchorEl: HTMLElement | null;
    onClose: () => void;
    onPick: (tab: PostProcessingTab) => void;
}

export default function PostProcessingMenu({
    anchorEl,
    onClose,
    onPick,
}: PostProcessingMenuProps) {
    return (
        <Menu
            open={anchorEl !== null}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{ vertical: 'center', horizontal: 'left' }}
            transformOrigin={{ vertical: 'center', horizontal: 'right' }}
            MenuListProps={{ dense: true }}
            data-testid="post-processing-menu"
        >
            {/* Nothing is marked current: the list asks which operation,
                and an entry shown as selected before one is picked reads as
                a choice already made. */}
            {POST_PROCESSING_TABS.map(({ value, labelId, Icon }) => (
                <MenuItem
                    key={value}
                    onClick={() => onPick(value)}
                    data-testid={`post-processing-menu-${value}`}
                >
                    {/* The same icon the tab strip shows, so an operation
                        is recognisable by sight from either route. */}
                    <ListItemIcon sx={{ minWidth: 32 }}>
                        <Icon />
                    </ListItemIcon>
                    <ListItemText primary={<FormattedMessage id={labelId} />} />
                </MenuItem>
            ))}
        </Menu>
    );
}
